export const APP_NAME = 'xplat360';

export const STRINGS = {
  app: {
    name: APP_NAME,
  },
  layout: {
    headerTitle: 'X-Plat',
  },
  home: {
    welcome: `Welcome to ${APP_NAME}`,
    viteAlt: 'Vite',
  },
  xPlat: {
    loading: 'Loading...',
    xplatAlt: 'Xplat',
  },
  errors: {
    unexpected: 'Unexpected error',
    xplatContextOutOfProvider: 'useXplatContext must be used within XplatProvider',
  },
} as const;

export type Strings = typeof STRINGS;
